<template>
    <div>
        <el-tabs value="tab_user" type="border-card" v-model="activeName">
            <el-tab-pane label="保司信息" name="tab_user">
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import VueJsonEditor from '@/components/VueJsonEditor'

    //其他控件: https://segmentfault.com/a/1190000009633257
    export default {
        components: {VueJsonEditor},
        data() {
            return {
                activeName : 'tab_user',
            };
        },
        created() {
            this.current_app = this.$store.state.app
        },

        computed: {
            cur_app() {
                return this.$store.state.app;
            }
        },
        watch:{
            $route(to){
                if (this.current_app === this.$store.state.app) {
                    return
                }
            }
        },
        methods: {
        },
    };

</script>

<style>
    .user-table-expand {
        font-size: 0;
    }

    .user-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .user-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }

    .hide-expand .el-table__expand-column .el-icon {
        visibility: hidden;
    }
</style>
